<template>
  <div v-bem>
    <div v-bem:content>
      <span v-bem:close @click="$emit('close-clicked')">&times;</span>
      <p v-bem:title>{{!model.stock_epuise ? $t('form.discount.title') : $t('form.out-of-stock.title')}} <span>{{!model.stock_epuise ? $t('form.discount.sub-title') : $t('form.out-of-stock.sub-title')}}</span></p>
      <Loader v-if="submitStatus === 'PENDING'" />
      <form @submit.prevent="submit" class="row form" v-if="submitStatus !== 'PENDING'">
        <div class="col-6 col-m-6">
          <div class="form-control">
            <input
              v-model="$v.user.lastname.$model"
              type="text"
              name="lastname"
              :class="{error: $v.user.lastname.$dirty && $v.user.lastname.$invalid}"
              :placeholder="`${$t('form.lastname')} *`"
            >
            <div class="errors" v-if="$v.user.lastname.$dirty">
              <p v-if="!$v.user.lastname.required">{{$t('form.error.required.lastname')}}</p>
              <p v-if="!$v.user.lastname.custom_alpha">{{$t('form.error.lettres.lastname')}}</p>
              <p v-if="!$v.user.lastname.minLength">{{$t('form.error.min.lastname')}}</p>
              <p v-if="!$v.user.lastname.maxLength">{{$t('form.error.max.lastname')}}</p>
            </div>
          </div>
        </div>
        <div class="col-6 col-m-6">
          <div class="form-control">
            <input
              v-model="$v.user.firstname.$model"
              type="text"
              name="firstname"
              :class="{error: $v.user.firstname.$dirty && $v.user.firstname.$invalid}"
              :placeholder="`${$t('form.firstname')} *`"
            >
            <div class="errors" v-if="$v.user.firstname.$dirty">
              <p v-if="!$v.user.firstname.required">{{$t('form.error.required.firstname')}}</p>
              <p v-if="!$v.user.firstname.custom_alpha">{{$t('form.error.lettres.firstname')}}</p>
              <p v-if="!$v.user.firstname.minLength">{{$t('form.error.min.firstname')}}</p>
              <p v-if="!$v.user.firstname.maxLength">{{$t('form.error.max.firstname')}}</p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-control">
            <input
            v-model="$v.user.email.$model"
            type="email"
            name="email"
            :class="{error: $v.user.email.$dirty && $v.user.email.$invalid}"
            :placeholder="`${$t('form.email')} *`"
            >
            <div class="errors" v-if="$v.user.email.$dirty">
              <p v-if="!$v.user.email.required">{{$t('form.error.required.email')}}</p>
              <p v-if="!$v.user.email.custom_email">{{$t('form.error.valid.email')}}</p>
            </div>
          </div>
          <div class="form-control">
            <input
              v-model="$v.user.phone.$model"
              type="tel"
              name="phone"
              :class="{error: $v.user.phone.$dirty && $v.user.phone.$invalid}"
              :placeholder="`${$t('form.phone')} *`"
            >
            <div class="errors" v-if="$v.user.phone.$dirty">
              <p v-if="!$v.user.phone.required">{{$t('form.error.required.phone')}}</p>
              <p v-if="!$v.user.phone.custom_phone">{{$t('form.error.valid.phone')}}</p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-control checkbox" :class="{error: $v.user.terms.$dirty && $v.user.terms.$invalid}">
            <label>{{$t('notices.terms')}} <a :href="`https://www.succursalesrenault.ma/pages/informations_legales`" target="_blank">{{$t('notices.terms-link')}}</a> *
              <input v-model="$v.user.terms.$model" type="checkbox" name="terms" @change="$v.user.terms.$touch()">
              <span></span>
            </label>
          </div>
          <div class="errors" v-if="$v.user.terms.$dirty">
            <p v-if="!$v.user.terms.sameAs">{{$t('form.error.required.terms')}}</p>
          </div>
          <div class="text-center">
            <div class="errors">
              <p class="text-center" v-if="submitStatus === 'SUBMIT_ERROR'">{{$t('form.error.send')}}</p>
            </div>
            <button type="submit" class="button button--primary"><span class="button__text">{{!model.stock_epuise ? $t('cta.discover') : $t('cta.send')}}</span></button>
            <div class="asterisks">
              <p>{{$t('notices.required')}}</p>
              <p v-html="$t('notices.law')"></p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import axios from 'axios'
import { helpers, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
const custom_alpha = helpers.regex('custom_alpha', /^[a-zA-Z ]+$/)
const custom_phone = helpers.regex('custom_phone', /^((05)|(06)|(07))[0-9]{8}$/)
const custom_email = helpers.regex('custom_email', /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)

export default {
  name: 'FormPopin',
  components: {
    Loader: () => import('@/components/Loader.vue')
  },
  mixins: [validationMixin],
  data: () => ({
    brand: process.env.VUE_APP_THEME,
    submitStatus: '',
    user :{
      lastname : '',
      firstname: '',
      phone    : '',
      email    : '',
      terms    : ''
    },
  }),
  validations: {
    user : {
      lastname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      firstname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      phone: {
        required,
        custom_phone,
      },
      email: {
        required,
        custom_email,
      },
      terms: { sameAs: sameAs( () => true ) }
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) this.submitStatus = 'ERROR'
      else {
        this.submitStatus  = 'PENDING'
        axios.post('https://succursalesrenault.ma/onlinestore/admin/public/api/preinscription', {
          ...this.user,
          model   : this.model.nom_lien.toLowerCase(),
          source  : this.utm.source,
          campaign: this.utm.campaign
        })
          .then(({status, data: userId}) => {
            if (status === 200 || status === 201) {
              let storeUser = localStorage.getItem('storeUser')
              storeUser = storeUser ? JSON.parse(storeUser) : {}
              localStorage.setItem('storeUser', JSON.stringify({
                ...storeUser,
                id       : userId,
                lastname : this.user.lastname,
                firstname: this.user.firstname,
                phone    : this.user.phone,
                email    : this.user.email,
              }))
              const params = new URLSearchParams()
              params.append('id_commande', userId)
              params.append('nom', this.user.lastname + ' ' + this.user.firstname)
              params.append('brand', 'Renault')
              params.append('telephone', this.user.phone)
              params.append('email', this.user.email)
              params.append('modele', this.model.nom_lien.toLowerCase())
              if(this.model.stock_epuise) params.append('type_demande', 'Stock épuisé Onlinestore')
              params.append('PassKey', process.env.VUE_APP_TELUS_KEY)
              window.telus.post('/Save_Ld_CB.php', params)
                .then(({status}) => {
                  if (status === 200 || status === 201) {
                    this.$store.dispatch('setModel', '')
                    EventBus.$emit('form-submited')
                    this.$emit('close-clicked')
                    this.submitStatus = 'SENT'
                    gtag('event', 'conversion', {'send_to': 'AW-774209629/U0ebCOCE1OEBEN2AlvEC'})
                  }
                  else this.submitStatus = 'SUBMIT_ERROR'
                })
                .catch(err => {
                  this.submitStatus = 'SUBMIT_ERROR'
                  console.error(err)
                })
            }
            else this.submitStatus = 'SUBMIT_ERROR'
          })
          .catch(err => {
            this.submitStatus = 'SUBMIT_ERROR'
            console.error(err)
          })
      }
    }
  },
  computed: {
    ...mapGetters([
      'model',
      'utm'
    ])
  },
  created() {
    let storeUser = localStorage.getItem('storeUser')
    storeUser = storeUser ? JSON.parse(storeUser) : {}
    this.user = {...this.user, ...storeUser}
  }
}
</script>

<style scoped lang="scss">
.form-popin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999999999;
  background-color: rgba($black, 0.7);
  &__content {
    @extend %transform-center;
    background-color: $white;
    width: 95%;
    max-width: rem(520);
    padding: rem(30) rem(16);
  }
  &__close {
    position: absolute;
    top: rem(4);
    right: rem(12);
    @include font-size(22);
    font-weight: bold;
    cursor: pointer;
  }
  &__title {
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    @include font-size(22);
    margin-bottom: rem(30);
    span {
      display: block;
      color: $dark-gray;
      @include font-size(14);
      font-weight: normal;
      text-transform: initial;
      max-width: rem(380);
      margin: rem(4) auto 0;
    }
  }
}
</style>